<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Convênios TCE/MA</h4>
      </v-alert>
  
      <v-row>
        <v-col cols="12" md="2" style="margin-top: 1.8%">
          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            to="/convenios/0"
            :disabled="!userHasPermission()"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>

      <template>
        <v-data-table
          :headers="headers"
          :items="lista"
          :items-per-page="5"
          class="elevation-1"
          no-results-text="A busca não trouxe resultados."
          no-data-text="A busca não trouxe resultados."
        >
          <template v-slot:item.numeroProcesso="{ item }">
            {{ item.numeroProcesso }}/{{ item.anoProcesso }}
          </template>

          <template v-slot:item.dataAssinaturaFormatada="{ item }">
            <span>
              {{
                item.dataAssinatura
                  ? $moment(item.dataAssinatura).format("DD/MM/YYYY")
                  : "Não Informado"
              }}
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item)"
                  :disabled="!userAdm()"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <v-dialog :retain-focus="false" v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >Confirma a exclusão do item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </app-layout>
</template>

<script>
import convenioService from "@/service/ConvenioService";

export default {
  data() {
    return {
      deleteId: null,
      dialogDelete: false,
      // filtro: {
      //   numeroProcesso: null,
      //   orgao: null,
      //   cpfCnpj: null,
      //   sancionado: null,
      //   inicioSancao: null,
      //   fimSancao: null,
      // },
      lista: [],
      headers: [
        //{ text: "ID", value: "convenioId", sortable: false, width: "5%" },
        { text: "Tipo", value: "tipoConvenio.descricao", sortable: false },
        { text: "Número/Ano", value: "numeroAnoParceria", sortable: false },
        { text: "Data Assinatura", value: "dataAssinaturaFormatada", sortable: false },
        { text: "Parceiro", value: "convenente", sortable: false },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          align: "center",
          width: "8%",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.$router.push("/convenios/" + item.convenioId);
    },
    deleteItem(item) {
      this.deleteId = item.convenioId;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteId != null) {
        convenioService.excluir(this.deleteId)
          .then(() => convenioService.findAll().then((res) => (this.lista = res)))
          .catch(() => (this.lista = []));
        this.deleteId = null;
        //this.lista = [];
      }
      this.closeDelete();
    },
    buscar() {
      //
    },

    closeDelete() {
      this.dialogDelete = false;
      this.deleteId = null;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
  },

  mounted() {
    convenioService.findAll()
      .then((res) => (this.lista = res))
      .catch(() => (this.lista = []));
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
